import { Icon as BlueprintIcon, IconName } from '@blueprintjs/core'
import classNames from 'classnames'
import React from 'react'

import { Icon as CustomIcon, IconNames } from '../custom-icon'

export type IconValue = IconName | IconNames

interface IIconProps {
  name?: IconValue
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

export const Icon: React.FC<IIconProps> = ({ name, size, color, className, style }) => {
  if (!name) {
    return null
  }

  if (Object.values(IconNames).includes(name as IconNames)) {
    return <CustomIcon icon={name as IconNames} size={size}/>
  }

  return (
    <BlueprintIcon
      icon={name as IconName}
      size={size}
      color={color}
      className={classNames(className)}
      style={style}
    />
  )
}
